import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';
import {ITranslate} from '../../services/LocalizationService';
import {CONNECTION_STATUS} from '../../services/ts-locale-helper/ts-locale-helper.settings';
import {DashboardState} from '../../states/dashboard/_contracts/DashboardState';

export type ClickHandler = () => void;
export interface EndMeetingEventHandlers {
    onEndMeeting: ClickHandler;
    onLeaveMeeting: ClickHandler;
    onLeaveOfflineRoom: ClickHandler;
    onExitOfflineMode: ClickHandler;
}

export class TsEndMeetingController {
    public CONNECTION_STATUS: typeof CONNECTION_STATUS;

    public isFF: boolean;

    constructor(
        public dashboardState: DashboardState,
        public eventHandlers: EndMeetingEventHandlers,
        public translate: ITranslate,
        private environmentService: ITsEnvironmentDetect
    ) {
        this.CONNECTION_STATUS = CONNECTION_STATUS;
        this.isFF = environmentService.isFF();
    }

    endMeeting = (e: React.MouseEvent) => {
        e.preventDefault();
        this.eventHandlers.onEndMeeting();
    };

    leaveMeeting = (e: React.MouseEvent) => {
        e.preventDefault();
        this.eventHandlers.onLeaveMeeting();
    };

    leaveOfflineRoom = (e: React.MouseEvent) => {
        e.preventDefault();
        this.eventHandlers.onLeaveOfflineRoom();
    };

    exitOfflineMode = (e: React.MouseEvent) => {
        e.preventDefault();
        this.eventHandlers.onExitOfflineMode();
    };
}
